import React from 'react'
import { Redirect } from 'react-router-dom'

export default () => {
    const organizerId = localStorage.getItem('organizerId')
    return <Redirect to={{ pathname: `/organizers/${organizerId}` }} />
}